const principles = [
  { icon: "ri-scales-3-line", title: "不造谣不传谣", desc: "对信息分级标注「已证实 / 待核实 / 网传」，帮你冷静吃瓜不踩坑。" },
  { icon: "ri-time-line", title: "脉络化整理", desc: "把碎片热搜还原成完整时间线，让每块瓜都有清晰的前因后果。" },
  { icon: "ri-node-tree", title: "知识图谱化", desc: "按人物、事件、领域、时间多维索引，信息不再是一盘散沙。" },
  { icon: "ri-eye-2-line", title: "来源可溯", desc: "尽可能注明信息出处与更新时间，把判断的依据还给你。" },
];

export default function About() {
  return (
    <section id="about" className="w-full scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600 mb-2">
              <span className="inline-block h-px w-8 bg-primary-400"></span>ABOUT US
            </p>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              把全网热闹，
              <br />
              整理成<span className="text-primary-600">看得懂的情报</span>
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              吃瓜百科诞生于一个朴素的愿望——当热搜越来越快、信息越来越碎，我们想做一个能让人慢下来、看清来龙去脉的合集导航。
              我们不做情绪煽动，只做冷静的目录与索引：把被刷屏冲散的话题按逻辑重新归位，让你在信息过载的时代，也能高效找到真正想看的内容。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里没有碎片化的东拼西凑，只有按人物、事件、领域与时间整理好的知识图谱。
              无论你是追连续剧式长瓜的老手，还是刚入门的吃瓜新人，这份目录都为你敞开。
            </p>
          </div>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {principles.map((p) => (
              <li
                key={p.title}
                className="rounded-xl border border-background-200 bg-background-100/80 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-800 text-xl">
                  <i className={p.icon}></i>
                </span>
                <h3 className="mt-3 font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className="relative mt-14 overflow-hidden rounded-2xl bg-primary-600">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20people%20reading%20newspapers%20and%20sharing%20gossip%20around%20a%20table%20with%20tea%20and%20watermelon%2C%20terracotta%20orange%20cream%20gold%20palette%2C%20cozy%20editorial%20scene%2C%20soft%20paper%20texture&width=1600&height=500&seq=chigua-cta-01&orientation=landscape"
              alt="吃瓜百科一起追更插画"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="relative flex flex-col items-center px-6 py-12 md:py-16 text-center">
            <h3 className="font-display text-2xl md:text-3xl font-bold text-background-50">
              今天也在吃瓜？别错过这块情报站
            </h3>
            <p className="mt-3 max-w-xl text-sm md:text-base text-background-100">
              收藏这份合集导航，随时回来补课。关注热点、按兴趣翻阅，一起把每一块瓜都吃得明明白白。
            </p>
            <a
              href="#trending"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 hover:bg-accent-100 transition-colors"
            >
              <i className="ri-fire-line text-lg"></i>
              去看看今日热榜
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}